import React from "react";
import styled, { withTheme } from "styled-components";
import Paper from "../../ui-library/Paper/Paper";
import TargetItem from "./TargetItem";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { useTranslation } from "react-i18next";
import { studyStatusesGSDIII } from "../../../modules/constants";

const ButtonsWrapper = styled.div`
  position: initial;
  margin-top: -50px;
  float: right;
`;

const ActionButton = styled(PrimaryButton)`
  padding: 5px 10px;

  &:first-child {
    margin-right: 4px;
  }
`;

const Targets = (props) => {
  const {
    goalsList,
    canCreateNewTarget,
    onEdit,
    canViewTargetsHistory,
    onViewHistory,
    studyStatus,
  } = props;

  const { t } = useTranslation();

  return (
    <Paper
      header={
        studyStatus === studyStatusesGSDIII.SAD_PERIOD.id
          ? t("contentText.dietDiary.targets.title.sadPeriod")
          : t("contentText.dietDiary.targets.title")
      }
      data-testid="goals"
    >
      {studyStatus !== studyStatusesGSDIII.SAD_PERIOD.id && (
        <ButtonsWrapper key="buttons-wrapper">
          {canViewTargetsHistory && (
            <ActionButton
              data-testid="view-history-button"
              size="sm"
              onClick={onViewHistory}
            >
              <i className="fas fa-history" />
            </ActionButton>
          )}

          {canCreateNewTarget && (
            <ActionButton
              data-testid="edit-button"
              size="sm"
              onClick={() => onEdit()}
            >
              <i className="fas fa-edit" />
            </ActionButton>
          )}
        </ButtonsWrapper>
      )}

      {goalsList?.map(function (item, index) {
        return <TargetItem data-testid="goal-item" key={index} {...item} />;
      })}
    </Paper>
  );
};
export default withTheme(Targets);
